
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import AppBadge from '@/components/AppBadge.vue';
import { NAVIGATION_PAGES } from '@/types/enums';
import { INavigation } from '@/types/interfaces';

export default defineComponent({
  components: {
    AppBadge,
  },
  props: {
    navigationData: { type: Object as () => INavigation[], required: true },
    useAsSelect: { type: Boolean, default: false },
    selectedTab: { type: String, default: 'contacts' },
  },
  setup() {
    const route = useRoute();
    const selectedPage = computed(() => route.meta.navigationPage);

    return {
      selectedPage,
      NAVIGATION_PAGES,
    };
  },
});
